import { useState } from "react";
import { cn } from "@/lib/utils";

export const Field = ({ label, required, children, className }) => (
  <label className={cn("block", className)}>
    <span className="mono block text-[0.6rem] text-[#8b95a5]">
      {label}
      {required && <span className="ml-1 text-[#e2c89d]">*</span>}
    </span>
    {children}
  </label>
);

export const Input = ({ className, ...p }) => <input className={cn("field", className)} {...p} />;
export const Textarea = ({ className, rows = 4, ...p }) => <textarea rows={rows} className={cn("field resize-none", className)} {...p} />;
export const Select = ({ className, children, ...p }) => (
  <select className={cn("field appearance-none pr-6", className)} {...p}>
    {children}
  </select>
);

export const useForm = (initial) => {
  const [v, setV] = useState(initial);
  const bind = (k) => ({ value: v[k] ?? "", onChange: (e) => setV((s) => ({ ...s, [k]: e.target.value })) });
  return [v, setV, bind];
};
